import { render, staticRenderFns } from "./relevantProduct.vue?vue&type=template&id=1e19a15a&scoped=true&"
import script from "./relevantProduct.vue?vue&type=script&lang=js&"
export * from "./relevantProduct.vue?vue&type=script&lang=js&"
import style0 from "./relevantProduct.vue?vue&type=style&index=0&id=1e19a15a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e19a15a",
  null
  
)

export default component.exports